import styled from "styled-components";

export const StyledCreateRoom = styled.div`
  padding: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 724px;

  .input-style {
    width: 70%;
  }
  button {
    width: 30%;
    min-width: 160px;
  }

  .description {
    color: rgba(0,0,0,0.25);
    font-size: 14px;
    margin-top: 56px;
  }

  @media only screen and (max-width: 600px) {
    .input-style, button {
      width: 100%;
    }
  }
`